import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Headers, Http, Response, URLSearchParams } from '@angular/http';
import { HttpUtilityService } from '../../../shared/http-utility.service';
import { FeedSearchResult } from './models/feed-search-result.model';
import { EventLoggerService } from '../../../shared/event-logger.service';
import { ErrorManagerService } from '../../../shared/error-handling/error-manager.service';
import { FeedService } from './feed.service';

@Injectable()
export class FeedServiceImpl implements FeedService {

    constructor(private http: Http, private httpUtility: HttpUtilityService, private eventLogger: EventLoggerService, private errorManager: ErrorManagerService) { }

    get(feedName: string, urlSearchParams: URLSearchParams): Observable<FeedSearchResult> {
        const headers: Headers = this.httpUtility.getHeaders();
        const url: string = this.httpUtility.buildUrl(feedName);

        return this.http
            .get(url, { headers: headers, search: urlSearchParams })
            .map(this.processResponse);
    }

    export(feedName: string, urlSearchParams: URLSearchParams): Observable<any[]> {
        const headers: Headers = this.httpUtility.getHeaders();
        const url: string = this.httpUtility.buildUrl(feedName);

        return this.http
            .get(url, { headers: headers, search: urlSearchParams })
            .map(this.processExportResponse);
    }

    private processResponse(response: Response) {
        // console.log(response);
        if (response.status < 200 || response.status >= 300) {
            const error = new Error(response.status + ':' + response.json());
            error.name = response.statusText;
            if (response.status === 404) {
                this.errorManager.handleNotFound('', 'Page Not Found');
                return;
            }
            this.eventLogger.logError(error, error.message, {});
            throw error;
        }
        const body = response.json();
        return body || {};
    }

    private processExportResponse(response) {
        if (response.status < 200 || response.status >= 300) {
            const error = new Error(response.status + ':' + response.json());
            error.name = response.statusText;
            if (response.status === 404) {
                this.errorManager.handleNotFound('', 'Page Not Found');
                return;
            }
            this.eventLogger.logError(error, error.message, {});
            throw error;
        }
        const body = response._body;
        return body || {};
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/feed-impl.service.ts